import { get } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, SubmissionError, Field, change } from 'redux-form';
import { renderTextField } from '../../../assets/formComponent';
import { firebaseSignup, firebaseSigninRedirect } from '../../../actions/auth';
import { load } from '../../../actions/common';
import { validateEmail, validatePassword } from '../../../assets/util';
import { getTranslate } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import CheckboxComponent from '../../form/CheckboxComponent';
// import { PRICEZA_MERCHANT_ID } from '../../../assets/constant';

class SignupForm extends Component {

    constructor(props) {
        super(props);
        // this.state = { firebaseSignupErr: null };
        // this.fbSignupClick = this.fbSignupClick.bind(this);
        this.firebaseFbLogin = this.firebaseFbLogin.bind(this);
        this.firebaseGgLogin = this.firebaseGgLogin.bind(this);
        this.firebaseAppleLogin = this.firebaseAppleLogin.bind(this);
    }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props.authError === "" && nextProps.authError === "SIGNUP_NEED") {
    //         const {change} = nextProps;
    //         const {fbResponse} = this.props;
    //         change("popupSignupForm", 'first_name', fbResponse.first_name);
    //         change("popupSignupForm", "last_name", fbResponse.last_name);
    //         change("popupSignupForm", "email", fbResponse.email);
    //     }
    // }

    onSubmit(values) {
        const errObj = { _error: "Submit failed" };
        let error = false;
        if (!values.first_name) {
            error = true;
            errObj.first_name = "Name is required";
        }
        if (!values.last_name) {
            error = true;
            errObj.last_name = "Lastname is required";
        }
        if (!values.email) {
            error = true;
            errObj.email = "Email is required";
        } else if (!validateEmail(values.email)) {
            error = true;
            errObj.email = "Email is invalid.";
        }
        if (!values.password) {
            error = true;
            errObj.password = "Password is required";
        } else if (!validatePassword(values.password)) {
            error = true;
            errObj.password = "Password needs to be more than 8 characters.";
        }

        if (error) {
            throw new SubmissionError(errObj);
        } else {
            //PriceZA tracking conversion
            // window.PZ3.process([{
            //     type: 'purchase',
            //     merchantId: PRICEZA_MERCHANT_ID, 
            //     filter: 'MEMBER-SIGNUP'
            // }]);

            this.props.firebaseSignup({ email: values.email, password: values.password, first_name: values.first_name, last_name: values.last_name, email_consent: values.email_consent });
        }
    }

    firebaseFbLogin() {
        this.props.firebaseSigninRedirect("facebook");
    }

    firebaseGgLogin() {
        this.props.firebaseSigninRedirect("google");
    }

    firebaseAppleLogin() {
        this.props.firebaseSigninRedirect("apple");
    }

    render() {
        const { handleSubmit, signupErr, translate, q } = this.props;
        return (
            <form className="" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                {(signupErr !== null || Boolean(get(q, "error", null))) && <div className="err-alert form-group px-0">
                    <div className="alert alert-danger col-12" role="alert">
                        {translate(`ERROR.AUTH.${get(signupErr, 'code', null)}`, get(signupErr, 'message', 'พบปัญหาขัดข้องบางประการ กรุณาติดต่อเจ้าหน้าที่ค่ะ'), { showMissingTranslationMsg: get(signupErr, 'message', 'พบปัญหาขัดข้องบางประการ กรุณาติดต่อเจ้าหน้าที่ค่ะ') }) || translate(`ERROR.${get(q, "error", '').toUpperCase()}`)}
                    </div>
                </div>}
                <Field component={renderTextField} className="first-name" name="first_name" label="ชื่อ" type="text" />
                <Field component={renderTextField} className="last-name" name="last_name" label="นามสกุล" type="text" />
                <Field component={renderTextField} className="" name="email" label="Email" type="text" />
                <Field component={renderTextField} className="password-form" name="password" label="Password" type="password" />
                <Field component={CheckboxComponent} name="email_consent" label={<span>ฉันต้องการรับสิทธิพิเศษ และ โปรโมชั่นรวมถึงข่าวสาร จาก บ.บิวเทรี่ยม และ พันธมิตร ตามที่ระบุไว้ใน <Link style={{ color: "#db0032" }} to={`/privacy`}>นโยบายความเป็นส่วนตัว</Link></span>} type="password" />
                <div className={`py-2`}>การสมัครสมาชิกนี้เป็นการยอมรับ <Link style={{ color: "#db0032" }} to={`/tos`}>ข้อกำหนดและเงื่อนไข</Link> และ รับทราบ <Link style={{ color: "#db0032" }} to={`/privacy`}>นโยบายความเป็นส่วนตัว</Link></div>
                <div className="w-100"><button className="btn btn-black btn-login" type="submit">สมัครสมาชิก</button></div>
                <div className=" text-center">หรือ</div>
                <button className="btn btn-facebook mb-3" type="button" onClick={this.firebaseFbLogin} >สมัครสมาชิกด้วย Facebook</button>
                <button className="btn btn-secondary mb-3" type="button" onClick={this.firebaseGgLogin} >สมัครสมาชิกด้วย Google</button>
                <button className="btn btn-google" type="button" onClick={this.firebaseAppleLogin} >สมัครสมาชิกด้วย Apple</button>
            </form>
        );
    }
}

function mapStateToProps(state) {
    return {
        signupResult: state.auth.signupResult,
        signupErr: state.auth.signupErr,
        authenticated: state.auth.authenticated,
        authError: state.auth.error,
        fbResponse: state.misc.fbResponse,
        translate: getTranslate(state.locale),
    }
}
export default reduxForm({
    form: 'popupSignupForm'
})(connect(mapStateToProps, { change, load, firebaseSignup, firebaseSigninRedirect })(SignupForm));